import { useState } from 'react';

import BrandPopup from './BrandPopup';
import EditBrandPopup from './EditBrandPopup';


import BasicDataTable from '../../DataTable/BasicDataTable';
import BasicSearchComponent from '../../DataTable/BasicSearchComponent';
import ActivationModal from '../../Modals/ActivationModal';
import { useBrands } from '../../../hooks/product/useBrands';

const BrandTable = () => {
  const {
    brands,
    handlerSearchByType,
    toggleBrandStatus,
    handlerAddBrand,
  } = useBrands();

  const [isActivationModalOpen, setIsActivationModalOpen] =
    useState(false);

  const [selectedBrand, setSelectedBrand] = useState<{
    id: number;
    name: string;
    status: boolean;
  } | null>(null);

  const [isBrandPopupOpen, setIsBrandPopupOpen] =
    useState(false);

  const [isEditPopupOpen, setIsEditPopupOpen] =
    useState(false);

  const handleRegisterBrand = (brandData: {
    id: number;
    name: string;
  }) => {
    handlerAddBrand(brandData);
  };

  const handleUpdateBrand = (brandData: {
    id: number;
    name: string;
  }) => {
    handlerAddBrand(brandData);
  };

  const handleEditBrand = (brand: {
    id: number;
    name: string;
    status: boolean;
  }) => {
    setSelectedBrand(brand);
    setIsEditPopupOpen(true);
  };

  const columns = [
    {
      Header: 'Nombre',
      accessor: 'name',
    },
    {
      Header: 'Estado',
      accessor: 'status',
      Cell: ({ value }) => (
        <span
          className={`inline-flex rounded-full px-3 py-1 text-sm font-medium ${
            value
              ? 'bg-green-500 text-white'
              : 'bg-red text-white'
          }`}
        >
          {value ? 'Activo' : 'Inactivo'}
        </span>
      ),
    },
  ];

  const addButton = (
    <button
      className="inline-flex items-center rounded-md bg-primary px-4 py-2 text-white hover:bg-opacity-90"
      onClick={() => setIsBrandPopupOpen(true)}
    >
      + Nueva Marca
    </button>
  );

  const handleToggleBrandStatus = (brand: {
    id: number;
    name: string;
    status: boolean;
  }) => {
    setSelectedBrand(brand);
    setIsActivationModalOpen(true);
  };

  const handleConfirmToggleStatus = () => {
    if (selectedBrand) {
      toggleBrandStatus(selectedBrand.id);
    }

    setIsActivationModalOpen(false);
  };

  const handleCancelToggle = () => {
    setIsActivationModalOpen(false);
    setSelectedBrand(null);
  };

  const actions = [
    {
      key: 'edit',
      onClick: handleEditBrand,
    },
    {
      key: 'toggle',
      onClick: handleToggleBrandStatus,
    },
  ];

  return (
    <>
      <BasicDataTable
        columns={columns}
        data={brands}
        noDataMessage="No hay marcas disponibles."
        actions={actions}
        headerButton={addButton}
        searchComponent={
          <BasicSearchComponent
            onSearch={handlerSearchByType}
          />
        }
      />

      <ActivationModal
        isOpen={isActivationModalOpen}
        title={
          selectedBrand?.status
            ? '¿Desactivar Marca?'
            : '¿Activar Marca?'
        }
        message={
          selectedBrand?.status
            ? '¿Estás seguro de que deseas desactivar esta marca?'
            : '¿Estás seguro de que deseas activar esta marca?'
        }
        confirmText={
          selectedBrand?.status
            ? 'Desactivar'
            : 'Activar'
        }
        cancelText="Cancelar"
        onConfirm={handleConfirmToggleStatus}
        onCancel={handleCancelToggle}
      />

      <BrandPopup
        popupOpen={isBrandPopupOpen}
        setPopupOpen={setIsBrandPopupOpen}
        onRegister={handleRegisterBrand}
      />

      <EditBrandPopup
        popupOpen={isEditPopupOpen}
        setPopupOpen={setIsEditPopupOpen}
        onUpdate={handleUpdateBrand}
        selectedBrand={selectedBrand}
      />
    </>
  );
};

export default BrandTable;